<template>
	<div>
		<b-row>
			<div class="image-preview">
				<vue-loading :active.sync="isLoadingChangeImage" :is-full-page="false"/>
				<div v-if="imageDataPreview!=null" class="m-3"><div :style="imagesTool.avatar(imageDataPreview, 11)"></div></div>
				<replacement-vehicle-image :image="replacementVehicle.image" v-else/>
				<div class="actions p-3">
					<div class="mb-2" v-if="imageDataPreview"><b-badge variant="warning" >Potrdite zamenjavo slike</b-badge></div>
					<CButton v-if="showUploadDialog" title="Potrdi izbrano sliko" class=" mr-2" color="primary" @click.stop="click_changeImage" size="sm"><CIcon name="cil-check-alt"/></CButton>
					<CButton v-else title="Dodaj sliko" class=" mr-2 " color="primary" @click.stop="click_showUploadDialogToggle" size="sm"><CIcon name="cil-pencil"/></CButton>
					<CButton v-if="showUploadDialog" title="Prekliči zamenjavo" color="danger" @click.stop="click_showUploadDialogToggle" size="sm"><CIcon name="cil-x"/></CButton>
					<CButton v-else-if="replacementVehicle.image" title="Odstrani sliko" color="danger" @click.stop="removeImage" size="sm"><CIcon name="cil-trash"/></CButton>
				</div>
			</div>
		</b-row>
		<b-row v-if="showUploadDialog">
			<b-col>
				<b-form-file 
					v-on:change="previewImage"
					placeholder="Izberi sliko"
					accept=".jpg, .jpeg, .png"
					browse-text="Izberi"
					ref="image-input"
					size="sm"
					:file-name-formatter="formatFileName"/>
					<vue-loading :active.sync="isLoadingChangeImage" :is-full-page="false" loader="dots"/>
			</b-col>
		</b-row>
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>

<script>
import ReplacementVehicleImage from '@/views/components/ReplacementVehicleImage';
import { REPLACEMENT_VEHICLE_CHANGE_IMAGE } from "@/store/actions/replacementVehicles";
import imagesTool from '@/tools/images';

export default {
	name: 'replacement-vehicle-change-image',
	components: {
		'replacement-vehicle-image': ReplacementVehicleImage
	},
	props: {
		replacementVehicle: {
			type: Object,
			required: true
		}
	},
	methods: {
		changeAvatar: function() {
			this.isLoadingChangeImage = true;
			const imageData = this.imageData;
			this.$store.dispatch(REPLACEMENT_VEHICLE_CHANGE_IMAGE, { imageData, id: this.replacementVehicle.id })
				.then((responseData) => {
					setTimeout(() => {
						this.isLoadingChangeImage = false;
						this.imageDataPreview = null;
						this.imageData = null;
						this.showUploadDialog = false;
						this.replacementVehicle.image = responseData.image;
						this.replacementVehicle.image_name = responseData.image_name;
					}, 2000);
				})
				.catch(error => {
					this.isLoadingChangeImage = false;
					this.imageDataPreview = null;
					this.imageData = null;
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.$refs.toastr.e('Napaka pri spreminjanju slike nadomestnega vozila! (' + error.response.data.code + ' - ' +  error.response.data.message + ')');
					} else {
						this.$refs.toastr.e('Napaka! Prosimo poizkusite kasneje.');
					}
				});
		},
		click_showUploadDialogToggle: function () {
			this.showUploadDialog = !this.showUploadDialog;
			this.imageDataPreview = null;
			this.imageData = null;
		},
		click_changeImage: function () {
			if (this.imageData) {
				this.changeAvatar();
			} else {
				this.$refs.toastr.e('Izberite sliko!');
			}
		},
		removeImage: function () {
			this.$bvModal.msgBoxConfirm('Želite odstraniti sliko?', {
				title: 'Potrdite odstranjevanje slike',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.imageData = null;
					this.changeAvatar();
				}
			}).catch(err => {
				console.error(err);
			})
		},
		previewImage: function (event) {
			let input;
			if (event instanceof DragEvent) {
				this.imageData = event.dataTransfer.files[0];
				input = event.dataTransfer;
			} else {
				this.imageData = event.target.files[0];
				input = event.target;
			}
			if (input.files && input.files[0]) {
				if (input.files[0].type.toLowerCase().includes('image')) {
					if (input.files[0].size < 2097152) {
						let reader = new FileReader();
						reader.onload = (e) => {
							this.imageDataPreview = e.target.result;
						}
						reader.readAsDataURL(input.files[0]);
					} else {
						this.$refs['image-input'].reset();
						this.imageData = null;
						this.$refs.toastr.e('Slika je prevelika.');
					}
				} else {
					this.$refs['image-input'].reset()
					this.imageData = null;
					this.$refs.toastr.e('Naložite sliko formata jpg, jpeg ali png.');
				}
			}
		},
		formatFileName() {
			return 'Slika';
		}
	},
	data: function () {
		return {
			showUploadDialog: false,
			isLoadingChangeImage: false,
			imageData: null,
			imageDataPreview: null,
			imagesTool
		};
	},
	computed: {
	}
};
</script>
<style>
.image-preview {
	position: relative;
}
.image-preview .actions {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	text-align: center;
}
</style>